import { LlmSubjectKind } from '../../utils/apollo/graphqlSchema';
import ExplainWithAiSaveToAnalysisButton from './ExplainWithAiSaveToAnalysisButton';
import ExplainWithAiSaveToDashboardButton from './ExplainWithAiSaveToDashboardButton';
import { UnreachableCaseError } from 'ts-essentials';
import { MaybeNil } from '../../utils/interfaces';
import ExplainWithAiSaveButtonDisplay from './ExplainWithAiSaveButtonDisplay';

interface IProps {
  subjectKind: LlmSubjectKind;
  subjectId: MaybeNil<string>;
  currentResultRichText: string | null;
  trackAction: string;
  trackContext: string;
}

const ExplainWithAiSaveButton = ({
  subjectId,
  subjectKind,
  currentResultRichText,
  trackAction,
  trackContext,
}: IProps) => {
  if (!currentResultRichText) {
    return null;
  }
  if (!subjectId) {
    return (
      <ExplainWithAiSaveButtonDisplay
        subjectKind={subjectKind}
        // onClick={onSave}
        isPermitted={true}
        isDisabled={true}
        trackAction={trackAction}
        trackContext={trackContext}
      />
    );
  }
  switch (subjectKind) {
    case LlmSubjectKind.Analysis:
      return (
        <ExplainWithAiSaveToAnalysisButton
          analysisId={subjectId}
          currentResultRichText={currentResultRichText}
          trackContext={trackContext}
          trackAction={trackAction}
        />
      );
    case LlmSubjectKind.Dashboard:
      return (
        <ExplainWithAiSaveToDashboardButton
          dashboardBaseId={subjectId}
          currentResultRichText={currentResultRichText}
          trackContext={trackContext}
          trackAction={trackAction}
        />
      );
    default:
      throw new UnreachableCaseError(subjectKind);
  }
};

export default ExplainWithAiSaveButton;
